<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    @closed="$refs.form.resetFields()"
    :width="type == 7 || type == 8 || type == 9?'14%':'600px'"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>{{title}}</span>
    </div>
    <el-form
      :model="model"
      ref="form"
      :rules="rules"
      label-width="90px"
    >
      <el-row>
        <el-col :span="22" v-if="false">
          <el-form-item
            label="密码:"
            prop="password"
          >
            <el-input
              size="small"
              v-model.trim="model.password"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="type == 10">
        <el-col :span="22" >
          <el-form-item
            label="上报频率:"
            prop="password"
          >
            <el-input
              size="small"
              v-model.trim="val"
              type="number"
              class="number_class"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="radio" v-if="type < 7">
        <el-radio
          v-model="radio"
          label="1"
        >开</el-radio>
        <el-radio
          v-model="radio"
          label="0"
        >关</el-radio>
      </el-row>
      <el-row class="div_btn" v-if="type == 7 || type == 8 || type == 9">
          <el-button size="small" type="primary"  @click="command()">下发</el-button>
          <el-button size="small" @click="$emit('update:visible', false)">取消</el-button>
      </el-row>
    </el-form>

    <template slot="footer" v-if="type != 8 && type != 7 && type != 9">
      <el-button
        type="primary"
        plain
        size="small"
        @click="command()"
      >确定</el-button>
      <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button>

    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: undefined
    },
    type:{
      type:Number,
      default:4,
    },
    title:{type:String},
  },

  data() {
    return {
      radio: "1",
      order1: "",
      msg: "",
      val:'',
      model: {
        password: "888888",
        commandMsg: "",
        commandType: "DISPATCH",
        vehicleId: ""
      },
      rules: {
        password: [
          {
            required: true,
            message: "密码", //this.$t("login.username_rules"),
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    //不足4位数前面补0
    handlerError(str){
      let len = str.length;
      let o = null;
      switch(len){
        case 1:
          o = `000${str}`;
        break;
        case 2:
          o = `00${str}`;
        break;
        case 3:
          o = `0${str}`;
        break;
        case 4:
          o = str;
        break;
      }
      return o;
    },
    async command() {
      this.model.vehicleId = this.params.vehicleId;
      let CMD_ID = this.type == 4?'BC00':
                              this.type == 5?'BC01':
                              this.type == 6?'BC02':
                              this.type == 7?'BC03':
                              this.type == 8?'BC04':
                              this.type == 9?'BC05':'BC06';
      let str = this.handlerError(Number(this.val).toString(16).toUpperCase());
      let data = this.type == 4 || this.type == 5 || this.type == 6 ?`000${this.radio}`:this.type == 7 || this.type == 8 || this.type == 9?'0001':str;
      this.model.commandMsg = `<BMSSETPARA:888888,${CMD_ID},${data}>`;
      this.commandDown(this.model)
    },
    async commandDown(data) {
      try {
        if(this.val > 65535) throw{msg:'定位器上报频率范围值：0-65535'}
        if(this.val == '' && this.type == 10) throw{msg:'定位器上报频率范围值不能为空'}
        const params = {
          ...data
        };
        const { msg } = await this.$API.commandDown(params);
        this.msg = msg;
        this.$emit("update:visible", false);
        this.$msg({
          showClose: true,
          message: this.msg ,
          type: "success"
        });
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    }
  }
};
</script>
<style>
.number_class input::-webkit-outer-spin-button,
.number_class input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
.number_class input[type="number"]{
  -moz-appearance: textfield;
}
</style>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 30px 10px 0px 10px;
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.div_btn{
  text-align: center;
  padding-bottom: 20px;
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
.radio {
  margin-left: 40px;
}
</style>
